package pl.finn.forms.utils

val personSurname = "Nazwisko"
val personFirstName = "Imię"
val personPesel = "Numer PESEL"
val addressTown = "Miejscowość"
val addressZipCode = "Kod pocztowy"
val addressStreet = "Ulica"
val addressBuilding = "Nr budynku"
val addressApartmentNumber = "Nr lokalu"
val addressCommune = "Gmina"

val addPartOfSurname = "Dodaj człon"
val remove = "Usuń"

var fileExtensions = setOf(
  "7z", "avi", "CAdES", "css", "csv", "dgn", "doc",
  "docx", "dwf", "dwg", "dxf", "geotiff", "gif", "gml", "gz", "gzip", "html",
  "jp2", "jpeg", "jpg", "m4a", "mp3", "mp4", "mpeg", "mpeg4", "mpg", "odp", "ods",
  "odt", "ogg", "ogv", "ott", "PAdES", "pdf", "png", "ppt", "pptx", "rng", "rtf",
  "svg", "tar", "tif", "tiff", "tls", "txt", "wav", "XAdES", "xhtml", "xls",
  "xlsx", "xml", "XMLenc", "XMLsig", "xps", "xsd", "xsl", "xslt", "zip"
)

val emptyField = "Pole to jest wymagane"